
import trustPages from "../content/trust-pages.json";

import { PageHeader, } from "../components/shared";
export function LegalView({ kind }: { kind: "privacy" | "terms" | "support" }) {
  const copy = trustPages.pages[kind];
  return <><PageHeader eyebrow={copy.eyebrow} title={copy.title} description={copy.description} /><section className="legal-sheet">{copy.sections.map(([title, body], index) => <article key={title}><span>{String(index + 1).padStart(2, "0")}</span><div><h2>{title}</h2><p>{body}</p></div></article>)}</section><p className="legal-status">공개 안내 · {trustPages.publishedAt}</p></>;
}

